export const ROUTE_CREDIT_APP = 'ROUTE_CREDIT_APP';
export const ROUTE_CREDIT_RESULTS = 'ROUTE_CREDIT_RESULTS';
export const ROUTE_DEAL_SUMMARY = 'ROUTE_DEAL_SUMMARY';
export const ROUTE_RESERVATION = 'ROUTE_RESERVATION';
export const ROUTE_RESERVATION_DEALER_INFO = 'ROUTE_RESERVATION_DEALER_INFO';
export const ROUTE_TEST_DRIVE = 'ROUTE_TEST_DRIVE';
export const ROUTE_VIEW_OFFER = 'ROUTE_VIEW_OFFER';
export const ROUTE_MESSAGING = 'ROUTE_MESSAGING';
export const ROUTE_TO_PROTECTION_LIST = 'ROUTE_TO_PROTECTION_LIST';
export const ROUTE_TO_PROTECTION_DETAIL = 'ROUTE_TO_PROTECTION_DETAIL';
